module.exports = __webpack_public_path__ + "static/media/yellow_4.f5ecb03d.jpg";